export const LeadManagement = []

export const Capture = [
  {
    to: '/sales/wallet-card',
    title: 'AI B-Cards',
    icon: '/media/icons/duotune/general/gen008.svg',
    Permissions: 'all',
    subMenu: [
      {
        to: '/wallet-card',
        title: 'My Cards',
        parent: 'AI B-Cards',
        Permissions: 'all',
      },
      {
        to: '/card-templates',
        title: 'My Templates',
        parent: 'AI B-Cards',
        Permissions: 'all',
      },
      {
        to: '/promo-action',
        title: 'Card Offers',
        parent: 'AI B-Cards',
        Permissions: 'all',
      },
      {
        to: '/report-wallet-card',
        title: 'Reports',
        parent: 'AI B-Cards',
        Permissions: 'all',
      },
    ],
  },
  {
    to: '/sales/live-chat',
    title: 'LiveChat',
    icon: '/media/icons/duotune/communication/com014.svg',
    Permissions: 'all',
    subMenu: [
      {
        to: '#',
        title: 'Conversations',
        parent: 'LiveChat',
        Permissions: 'all',
      },
      {
        to: '#',
        title: 'Settings',
        parent: 'LiveChat',
        Permissions: 'all',
      },
    ],
  },
  {
    to: '/landing-page',
    title: 'Landing Pages',
    icon: '/media/icons/duotune/coding/cod006.svg',
    Permissions: 'all',
    subMenu: [
      {
        to: '/landing-page',
        title: 'Landing Page',
        parent: 'Landing Pages',
        Permissions: 'all',
      },
      {
        to: '/report-analytics/landing-page',
        title: 'Reports',
        parent: 'Landing Pages',
        Permissions: 'all',
      },
    ],
  },
  {
    to: '/tools/form',
    title: 'Lead Forms',
    icon: '/media/icons/lead-capture-form.svg',
    Permissions: 'all',
  },
]

export const Engagement = [
  {
    to: '/new-message',
    title: 'Send Campaign',
    icon: '/media/icons/duotune/navigationicon/communication.svg',
    Permissions: 'send-quick-sms',
    subMenu: [
      {
        to: '/new-message',
        title: 'SMS & MMS',
        parent: 'Send Campaign',
        Permissions: 'send-quick-sms',
      },
      {
        to: '#',
        title: 'Email',
        parent: 'Send Campaign',
        Permissions: 'send-quick-sms',
      },
      {
        to: '/report-analytics/bulk-messages',
        title: 'Reports',
        parent: 'Send Campaign',
        Permissions: 'all',
      },
      {
        to: '/templates/template',
        title: 'Message templates',
        parent: 'Send Campaign',
        Permissions: 'all',
      },
      {
        to: '/report-analytics/short-link',
        title: 'Short Link ',
        parent: 'Send Campaign',
        Permissions: 'all',
      },
    ],
  },
  {
    to: '#',
    title: 'Quick Message',
    icon: '/media/icons/duotune/communication/com007.svg',
    Permissions: 'all',
  },
  {
    to: '#',
    title: 'DB-Reactivation',
    icon: '/media/icons/duotune/graphs/gra004.svg',
    Permissions: 'all',
  },
  {
    to: '/automation',
    title: 'Flows & Automation',
    icon: '/media/icons/duotune/navigationicon/data.svg',
    Permissions: 'all',
  },
  {
    to: '/contacts/subscriber',
    title: 'Contacts',
    icon: '/media/icons/duotune/communication/com005.svg',
    Permissions: 'contacts-list',
  }
]

export const Convert = [
  {
    to: '/contact-collection',
    title: 'Lead Management',
    icon: '/media/icons/duotune/communication/com005.svg',
    Permissions: 'all',
  },
  {
    to: '/inbox',
    title: 'Inbox',
    icon: '/media/icons/duotune/navigationicon/messages.svg',
    Permissions: 'all',
  },
  {
    to: '#',
    title: 'Reviews',
    icon: '/media/icons/duotune/graphs/gra004.svg',
    Permissions: 'all',
  },
]

export const System = [
  {
    to: '/topup',
    title: 'Purchase Credit',
    icon: '/media/icons/duotune/navigationicon/cash.svg',
    fontIcon: '/media/icons/duotune/navigationicon/cash.svg',
    Permissions: 'purchase-credits',
  },
  {
    to: '/integrations',
    title: 'API & Integrations',
    icon: '/media/icons/duotune/coding/cod006.svg',
    Permissions: 'all',
    subMenu: [
      {
        to: '/accounts/api-keys',
        title: 'API Setup',
        parent: 'Api and Integrations',
        Permissions: 'all',
      },
      {
        to: '/integration',
        title: 'Integrations',
        parent: 'Api and Integrations',
        Permissions: 'all',
      },
      {
        to: '/email-to-sms',
        title: 'Email to SMS',
        parent: 'Api and Integrations',
        Permissions: 'all',
      },
      {
        to: '/report-analytics/activity-logs',
        title: 'Activity Logs',
        parent: 'Api and Integrations',
        Permissions: 'all',
      },
    ],
  },
  {
    to: '/accounts',
    title: 'Accounts',
    icon: '/media/icons/duotune/communication/com014.svg',
    Permissions: 'all',
    subMenu: [
      {
        to: '/accounts/referral',
        title: 'Affiliate',
        parent: 'My Account',
        // icon: '/media/icons/duotune/graphs/gra001.svg',
        // fontIcon: '/media/icons/duotune/graphs/gra001.svg',
        Permissions: 'create-auto-popup-setting',
      },
      {
        to: '/accounts/billing?scrollId=auto-fill',
        title: 'Auto Top-up',
        parent: 'My Account',
        // icon: '/media/icons/duotune/finance/fin002.svg',
        // fontIcon: '/media/icons/duotune/finance/fin002.svg',
        Permissions: 'create-auto-popup-setting',
      },
      {
        to: '/accounts/billing?scrollId=purchase-history',
        title: 'Billing',
        parent: 'My Account',
        // icon: '/media/icons/duotune/finance/fin010.svg',
        // fontIcon: '/media/icons/duotune/finance/fin010.svg',
        Permissions: 'create-auto-popup-setting',
      },
      {
        to: '/accounts/team-list',
        title: 'Users',
        parent: 'My Account',
        // icon: '/media/icons/duotune/users/users.svg',
        // fontIcon: '/media/icons/duotune/users/users.svg',
        Permissions: 'list-sub-accounts',
      },
    ],
  },
  {
    to: '/settings',
    title: 'Settings',
    icon: '/media/icons/duotune/general/gen008.svg',
    Permissions: 'all',
    subMenu: [
      {
        to: '/sender-id',
        title: "Sender ID's",
        parent: 'Settings',
        Permissions: 'all',
      },
      {
        to: '/accounts/overview',
        title: 'Global Settings',
        parent: 'Settings',
        Permissions: 'all',
      },
    ],
  },
]

export const Campaign = []

export const CampaignRegion = [
  ////////////////////////////////FRONTEND USER//////////////////////////////////////////////
  {
    to: '/message',
    icon: '/media/icons/duotune/navigationicon/bulkmsg.svg',
    title: 'Send Message',
    Permissions: 'all',
    subMenu: [
      {
        to: '#',
        icon: '',
        fontIcon: 'bi-send',
        title: 'Quick Message',
        Permissions: 'send-quick-sms',
      },
      {
        to: '/new-message',
        icon: '/media/icons/duotune/navigationicon/bulkmsg.svg',
        title: 'Send Campaign',
        Permissions: 'send-quick-sms',
      },
      // {
      //   to: '/templates/savedCampaign',
      //   title: 'Saved Campaigns',
      //   hasBullet: true,
      //   Permissions: 'segments-list',
      // },
      // {
      //   to: '/file-scheduler',
      //   icon: '/media/icons/duotune/files/fil016.svg',
      //   title: 'File Scheduler',
      //   Permissions: 'send-quick-sms',
      // },
    ],
  },
  {
    to: '/contacts',
    title: 'Contacts',
    icon: '/media/icons/duotune/communication/com005.svg',
    Permissions: 'contacts-list',
    subMenu: [
      {
        to: '/contacts/subscriber',
        title: 'All Contacts',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
      {to: '/contacts/list', title: 'List', hasBullet: true, Permissions: 'tags-list'},
      {to: '/contacts/tags', title: 'Tags', hasBullet: true, Permissions: 'tags-list'},
      // { to: '/contacts/segments', title: 'Segments', hasBullet: true, Permissions: 'segments-list' },
      {
        to: '/contacts/upload-history',
        title: 'Upload History',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
      {
        to: '/contacts/unsubscribe',
        title: 'Unsubscribed',
        hasBullet: true,
        Permissions: 'contacts-list',
      },
    ],
  },
  {
    to: '/report-analytics',
    icon: '/media/icons/duotune/graphs/gra007.svg',
    title: 'Reports & Analytics',
    Permissions: 'all',
    subMenu: [
      {
        to: '/report-analytics/bulk-messages',
        title: 'Campaign reports',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/report-analytics/activity-logs',
        title: 'Activity Log',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/report-analytics/flow',
        title: 'Flow Reports',
        hasBullet: true,
        Permissions: 'all',
      },
      // {
      //   to: '/report-analytics/quick-messages',
      //   title: 'Quick message',
      //   hasBullet: true,
      //   Permissions: 'all',
      // },
    ],
  },
]

export const More = []

export const MoreRegion = [
  {
    to: "/accounts/sender-id's",
    icon: '/media/icons/duotune/navigationicon/medal_star.svg',
    title: "Sender ID's",
    Permissions: 'show-dedicated-number',
  },
  {
    to: "/accounts/sender-id's",
    title: 'Dedicated Numbers',
    icon: '/media/icons/duotune/navigationicon/phone.svg',
    Permissions: 'purchase-dedicated-number',
  },
  {
    to: '/topup',
    title: 'Purchase credit ',
    icon: '/media/icons/duotune/navigationicon/cash.svg',
    Permissions: 'purchase-credits',
  },
  {
    to: '/integration',
    icon: '/media/icons/duotune/navigationicon/cloud.svg',
    title: 'Integrations',
    Permissions: 'all',
  },
  {
    to: '/setting',
    icon: '',
    fontIcon: 'bi-gear',
    title: 'Settings',
    Permissions: 'all',
    subMenu: [
      {
        to: '/email-to-sms',
        hasBullet: true,
        title: 'Email to SMS',
        Permissions: 'all',
      },
      {
        to: '/accounts/api-keys',
        title: 'API Setup',
        hasBullet: true,
        Permissions: 'all',
      },
      {
        to: '/accounts/billing?scrollId=purchase-history',
        title: 'Billing History',
        hasBullet: true,
        Permissions: 'create-auto-popup-setting',
      },
      {
        to: '/accounts/balance-history',
        title: 'Credit History',
        hasBullet: true,
        Permissions: 'create-auto-popup-setting',
      },
    ],
  },
]

export const Tools = []

export const WalletCard = []

export const WalletCardNotActivate = []
